module.exports = __webpack_public_path__ + "static/media/phone_section_nosotros.65d4b9d8.png";